import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { CmpImgCarousel } from 'app/core/cms/generated/api-types'
import { CarouselComponent } from 'app/shared/carousel/carousel.component'
import { CarouselItemDirective } from 'app/shared/carousel/carousel-item.directive'
import { ImageWidth, PictureComponent } from 'app/shared/picture/picture.component'
import { explicitComputed } from 'app/utils/signal-utils'

import { parseImgOptsRatio } from '../../block-utils'
import { CmsBlock } from '../../cms-block'
import { LayoutContainer } from '../../sections/layout-container'

@Component({
  selector: 'pai-cmp-img-carousel',
  templateUrl: './cmp-img-carousel.component.html',
  styleUrls: ['./cmp-img-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselComponent, CarouselItemDirective, PictureComponent],
  providers: [{ provide: CmsBlock, useExisting: CmpImgCarouselComponent }],
})
export class CmpImgCarouselComponent extends CmsBlock<CmpImgCarousel> {
  readonly __typename = 'CmpImgCarousel'

  protected readonly ratio = explicitComputed(this.data, (d) => parseImgOptsRatio(d.imageOptions?.ratio))

  protected get maxWidthLg(): ImageWidth {
    return this.parentLayout.containerInfo().maxWidthAtLg
  }
  protected get maxWidthXl(): ImageWidth {
    return this.parentLayout.containerInfo().maxWidthAtXl
  }

  private readonly parentLayout = inject(LayoutContainer)
}
